import { render, staticRenderFns } from "./areaManage.vue?vue&type=template&id=e7bb025c&scoped=true&"
import script from "./areaManage.vue?vue&type=script&lang=js&"
export * from "./areaManage.vue?vue&type=script&lang=js&"
import style0 from "./areaManage.vue?vue&type=style&index=0&id=e7bb025c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7bb025c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7bb025c')) {
      api.createRecord('e7bb025c', component.options)
    } else {
      api.reload('e7bb025c', component.options)
    }
    module.hot.accept("./areaManage.vue?vue&type=template&id=e7bb025c&scoped=true&", function () {
      api.rerender('e7bb025c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/bianlidianManage/onlineshop/areaManage.vue"
export default component.exports